// @ts-strict-ignore
import type { Action, SuppressionInterval } from 'flow/store/engine/types';
import { TAG_COLOR_HEX_TO_NAME_MAP } from './constants';
import { filterActionsByType } from '../actions';
import { ActionType } from 'flow/store/engine/constants';

export function generateSuppressionIntervalAsString(
  suppressionInterval: SuppressionInterval,
): string {
  const { unit, value } = suppressionInterval;

  return `${value} ${unit}`;
}


/**
 * Returns the color name for a given hex.
 * If no name exists, the hex is returned back
 */
export function getTagColorName(hex: string): string {
  return TAG_COLOR_HEX_TO_NAME_MAP.get(hex) ?? hex;
}

export function getTagActionsByTagName(actions: Record<string, Action>, tagName: string): Action[] {
  const tagActions = filterActionsByType(actions, ActionType.TAG);
  return tagActions
    .filter(action => action.tag.name === tagName);
}
